import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const DatePickerCustom = styled(DatePicker)`
  ${({ theme }) => css`
padding-left: 1rem;
max-height = 15,
width: 100%;
border: 3px solid "#f6f6f6";
border-radius: 4px;
color: #000;
font-size: 11px;
font-family: Roboto;
font-weight: 500;
`}
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Main = styled.main`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 100%;
  `}
`;

export const Label = styled.main`
  font-family: Roboto;
  font-size: 12px;
  line-height: 1.17;
  text-align: left;
  color: #747576;
  margin-bottom: 3.3px;
`;
